"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailAddressSeparatedInput = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var styles_1 = require("../../../styles");
var smallAndUp = styles_1.BREAKPOINTS.smallAndUp, lessThanSmall = styles_1.BREAKPOINTS.lessThanSmall;
var DELIMITER = '@';
var InputWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  @media (", ") {\n    flex-flow: row wrap;\n  }\n\n  label: SeparatedInputWrapper;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  @media (", ") {\n    flex-flow: row wrap;\n  }\n\n  label: SeparatedInputWrapper;\n"])), lessThanSmall);
var AT_SIGN_AREA_WIDTH = {
    sp: '20px',
    pc: '28px',
};
var InputItem = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  @media (", ") {\n    width: calc(50% - ", " / 2);\n  }\n  @media (", ") {\n    margin-bottom: ", ";\n    width: ", ";\n  }\n\n  label: ", ";\n"], ["\n  @media (", ") {\n    width: calc(50% - ", " / 2);\n  }\n  @media (", ") {\n    margin-bottom: ", ";\n    width: ", ";\n  }\n\n  label: ", ";\n"])), smallAndUp, AT_SIGN_AREA_WIDTH.pc, lessThanSmall, function (_a) {
    var first = _a.first;
    return (first && '8px') || 0;
}, function (_a) {
    var first = _a.first;
    return (first && '100%') || "calc(100% - ".concat(AT_SIGN_AREA_WIDTH.sp, ")");
}, function (_a) {
    var labelSuffix = _a.labelSuffix;
    return "MediaQuery-".concat(labelSuffix);
});
var AtSignArea = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  text-align: center;\n\n  label: AtSignArea;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  text-align: center;\n\n  label: AtSignArea;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var MailAddressSeparatedInput = function (_a) {
    var color = _a.color, localInput = _a.localInput, domainInput = _a.domainInput;
    return (react_1.default.createElement(InputWrapper, null,
        react_1.default.createElement(InputItem, { first: true, labelSuffix: "LocalInput" }, localInput),
        react_1.default.createElement(AtSignArea, { color: color }, DELIMITER),
        react_1.default.createElement(InputItem, { labelSuffix: "DomainInput" }, domainInput)));
};
exports.MailAddressSeparatedInput = MailAddressSeparatedInput;
var templateObject_1, templateObject_2, templateObject_3;
